import API from "../Utils/axios";


export const getScatterData = async (data, props) => {
  return await API.post(props?.block?.api_path, data);
};

